/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.home_advisor
 */
function homeAdvisorModalDirective() {
    return {
        restrict: 'E',
        scope: {},
        controllerAs: 'vm',
        controller: homeAdvisorModalController,
        template: require('./homeAdvisorModalView.html')
    };
}

homeAdvisorModalController.$inject = [
    '$sce',
    '$log',
    '$state',
    'AnalyticsService',
    'UtilService',
    'HomeAdvisorModalService'
];
function homeAdvisorModalController(
    $sce,
    $log,
    $state,
    AnalyticsService,
    UtilService,
    HomeAdvisorModalService
) {
    var vm = this;

    vm.siteTitle = UtilService.getSiteSetting('title');
    vm.bannerLogo = UtilService.getSiteSetting('banner_logo');

    HomeAdvisorModalService.registerOpenModalCallback(function () {
        vm.product = HomeAdvisorModalService.product;
        vm.homeAdvisorEmbedLink = $sce.trustAsResourceUrl(HomeAdvisorModalService.homeAdvisorEmbedLink);
    });

    vm.onCloseModal = function () {
        AnalyticsService.reportEvent('Promo Engaged', {
            type: 'home advisor',
            action: 'close modal',
            category: $state.params.category_code || null
        }, vm.product);
    };
}

module.exports = homeAdvisorModalDirective;
